<template>
    <div class="filter-view h-100">
        <div class="row g-0 vh-100">

            <div class="menu-btn" v-if="!showMenuBool">
                <button  @click="showMenu()">
                    <i class="bi bi-card-list"></i> Show Filters
                </button>
            </div>

            <div id="myStackernav" class="stackernav">
                <button class="close-btn" @click="showMenu()">
                    <i class="bi bi-x"></i>
                </button>
                <div class="filters h-100" @showDetail="showHide">
                    <div class="pt-5 heading">
                    </div>
                    <div class="filter-box mt-3 pb-5">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="filter-by">FILTER BY</div>
                            <div>
                                <button @click="Reset()" class="reset-btn"> 
                                    <img :src="require('../assets/img/reset.png')" />
                                    <!-- <i class="bi bi-arrow-repeat"></i> -->
                                </button>
                            </div>
                        </div>

                        <div class="filters-list mt-4">

                            <div class="fitler-one">
                                <p>BLOCK</p>
                                <div class="d-flex justify-content-between">

                                    <label class="chk-radio w-50">
                                        <input type="radio"  value="1" v-model="formValue['block']">
                                        <span class="checkmark"></span>
                                        A1
                                    </label>

                                    <label class="chk-radio w-50">
                                        <input type="radio"  value="2" v-model="formValue['block']">
                                        <span class="checkmark"></span>
                                        A2
                                    </label>
                                </div>
                            </div>

                            <div class="fitler-one">
                                <p>BEDROOMS</p>
                                <div class="d-flex justify-content-between">
                                    <label class="chk-radio w-50">
                                        <input type="radio" name="bedroom" value="1" v-model="formValue['bedroom']">
                                        <span class="checkmark"></span>
                                        1
                                    </label>

                                    <label class="chk-radio w-50">
                                        <input type="radio" name="bedroom" value="2" v-model="formValue['bedroom']">
                                        <span class="checkmark"></span>
                                        2
                                    </label>

                                    <!-- <label class="chk-radio">
                                        <input type="radio" name="bedroom" value="3" v-model="formValue['bedroom']">
                                        <span class="checkmark"></span>
                                        3
                                    </label> -->
                                </div>
                            </div>

                            <div class="fitler-two">
                                <p>FLOOR</p>
                                <div class="d-flex justify-content-between flex-wrap wrap-2">
                                    <label class="chk-radio">
                                        <input type="radio"  v-model="formValue['floor']" value="1">
                                        <span class="checkmark"></span>
                                        1
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" v-model="formValue['floor']" value="2">
                                        <span class="checkmark"></span>
                                        2
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" name="floor" v-model="formValue['floor']" value="3">
                                        <span class="checkmark"></span>
                                        3
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" name="floor" v-model="formValue['floor']" value="4">
                                        <span class="checkmark"></span>
                                        4
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" name="floor" v-model="formValue['floor']" value="5">
                                        <span class="checkmark"></span>
                                        5
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" name="floor" v-model="formValue['floor']" value="6">
                                        <span class="checkmark"></span>
                                        6
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" name="floor" v-model="formValue['floor']" value="7">
                                        <span class="checkmark"></span>
                                        7
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" name="floor" v-model="formValue['floor']" value="8">
                                        <span class="checkmark"></span>
                                        8
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" name="floor" v-model="formValue['floor']" value="9">
                                        <span class="checkmark"></span>
                                        9
                                    </label>
                                </div>
                            </div>

                            <div class="fitler-one">
                                <p>STATUS</p>
                                <div>

                                    <label class="chk-radio">
                                        <input type="radio" name="status" v-model="formValue['status']" value="0">
                                        <span class="checkmark"></span>
                                        LISTED PRICE
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" value="1" v-model="formValue['status']">
                                        <span class="checkmark"></span>
                                        RESERVED
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" name="status" v-model="formValue['status']" value="2">
                                        <span class="checkmark"></span>
                                        SOLD
                                    </label>

                                    <label class="chk-radio">
                                        <input type="radio" name="status" v-model="formValue['status']" value="3">
                                        <span class="checkmark"></span>
                                        UNRELEASED
                                    </label>
                                </div>
                            </div>

                            <!-- <div class="fitler-one ">
                                <p>Price</p>
                                <Slider
                                v-model="formValue.price_range"
                                :merge="merge"
                                :format="format"
                                :min="min"
                                :max="max"
                                />
                            </div> -->

                            <div class="mt-3 mb-5 ">
                                <button class="apply-btn mb-3" @click="FilterApply()">
                                    APPLY
                                </button> 
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="col-md-3 h-100 desktop">
                <div class="filters h-100 pb-5">
                        <div class="pt-5 heading">
                        </div>
                        <div class="filter-box mt-3 pb-5">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="filter-by">FILTER BY</div>
                                <div><button @click="Reset()" class="reset-btn"> 
                                    <img src="../assets/img/reset.png" />
                                </button></div>
                            </div>

                            <div class="filters-list mt-4">

                                <div class="fitler-one">
                                    <p>BLOCK</p>
                                    <div class="d-flex justify-content-between">
                                        <label class="chk-radio w-50">
                                            <input type="radio" name="block" value="1" v-model="formValue['block']">
                                            <span class="checkmark"></span>
                                            A1 
                                        </label>

                                        <label class="chk-radio w-50">
                                            <input type="radio" name="block" value="2" v-model="formValue['block']">
                                            <span class="checkmark"></span>
                                            A2
                                        </label>
                                    </div>
                                </div>

                                <div class="fitler-one">
                                    <p>BEDROOMS</p>
                                    <div class="d-flex justify-content-between">
                                        <label class="chk-radio w-50">
                                            <input type="radio" value="1" v-model="formValue.bedroom">
                                            <span class="checkmark"></span>
                                            1
                                        </label>

                                        <label class="chk-radio w-50">
                                            <input type="radio" value="2" v-model="formValue.bedroom">
                                            <span class="checkmark"></span>
                                            2
                                        </label>
                                    </div>
                                </div>

                                <div class="fitler-two">
                                    <p>FLOOR</p>
                                    <div class="d-flex justify-content-between flex-wrap">
                                        <label class="chk-radio">
                                            <input type="radio" name="floor" v-model="formValue['floor']" value="1">
                                            <span class="checkmark"></span>
                                            1
                                        </label>

                                        <label class="chk-radio">
                                            <input type="radio" name="floor" v-model="formValue['floor']" value="2">
                                            <span class="checkmark"></span>
                                            2
                                        </label>

                                        <label class="chk-radio">
                                            <input type="radio" name="floor" v-model="formValue['floor']" value="3">
                                            <span class="checkmark"></span>
                                            3
                                        </label>

                                        <label class="chk-radio">
                                            <input type="radio" name="floor" v-model="formValue['floor']" value="4">
                                            <span class="checkmark"></span>
                                            4
                                        </label>

                                        <label class="chk-radio">
                                            <input type="radio" name="floor" v-model="formValue['floor']" value="5">
                                            <span class="checkmark"></span>
                                            5
                                        </label>

                                        <label class="chk-radio">
                                            <input type="radio" name="floor" v-model="formValue['floor']" value="6">
                                            <span class="checkmark"></span>
                                            6
                                        </label>

                                        <label class="chk-radio">
                                            <input type="radio" name="floor" v-model="formValue['floor']" value="7">
                                            <span class="checkmark"></span>
                                            7
                                        </label>

                                        <label class="chk-radio">
                                            <input type="radio" name="floor" v-model="formValue['floor']" value="8">
                                            <span class="checkmark"></span>
                                            8
                                        </label>

                                        <label class="chk-radio">
                                            <input type="radio" name="floor" v-model="formValue['floor']" value="9">
                                            <span class="checkmark"></span>
                                            9
                                        </label>
                                        
                                </div>
                                </div>

                                <div class="fitler-one ">
                                    <p>STATUS</p>
                                    <div class="d-flex justify-content-between">
                                        <label class="chk-radio w-50">
                                            <input type="radio" value="0" v-model="formValue.status">
                                            <span class="checkmark"></span>
                                            AVAILABLE
                                        </label>
                                        <label class="chk-radio w-50">
                                            <input type="radio" value="1" v-model="formValue.status">
                                            <span class="checkmark"></span>
                                            RESERVED
                                        </label>

                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <label class="chk-radio w-50">
                                            <input type="radio" value="2" v-model="formValue.status">
                                            <span class="checkmark"></span>
                                            SOLD
                                        </label>

                                        <label class="chk-radio w-50">
                                            <input type="radio" value="3" v-model="formValue.status">
                                            <span class="checkmark"></span>
                                            UNRELEASED
                                        </label>
                                    </div>
                                </div>

                                <!-- <div class="fitler-one ">
                                    <p>Price</p>
                                    <Slider
                                    v-model="formValue.price_range"
                                    :merge="merge"
                                    :format="format"
                                    :min="min"
                                    :max="max"
                                    />
                                </div> -->
                            </div>

                            <div class="mt-3 mb-5 ">
                                <button class="apply-btn mb-3" @click="FilterApply()">
                                    APPLY
                                </button> 
                            </div>
                        </div>
                </div>
            </div>

            <div class="col-md-8 h-100 desktop-2">
                <div class="h-100 list-view">
                     <SearchFilterList :fromcms="false" :data="apartments"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchFilterList from "@/components/SearchFilterList/SearchFilterList.vue";
import Slider from '@vueform/slider'

export default {
  name: 'SearchFilterView',
  components: {
    SearchFilterList,
    Slider,
  },
    created() {
        document.title = "Filter - Heybourne Park";
        this.GetApartments();
        this.PageViewCount();
    },
    data(){
        return {
            min: 350000,
            max: 975000,
            merge: 50000,
            format: {
                prefix: '£',
                decimals: 2,
                thousand: ","
            },
            FetchNumber:"",
            apartments: [],
            apartments_two: [],
            formValue:{
                bedroom:"",
                floor:"",
                status:"",
                block:"",
                price_range:[350000, 975000],
            },
            showMenuBool: false,
        };
    },
    methods: {
        GetApartments(){
            fetch(this.base_url+'GetAllApartments')
            .then(response => response.json())
            .then(res => {
                //console.log(res.data.apartments)
                this.apartments = res.data.apartments;
                this.apartments_two = [...res.data.apartments]
            });
        },
        Reset(){
            this.formValue = [];
            this.formValue.price_range = [350000, 975000];
            this.apartments = this.apartments_two
        },
        FilterApply(){
            fetch(this.base_url+'Filter', {
                method: 'POST', // or 'PUT'
                // headers: {
                //     'Content-Type': 'application/json',
                // },
                body: JSON.stringify({
                    bedroom: this.formValue.bedroom,
                    block: this.formValue.block,
                    floor: this.formValue.floor,
                    status: this.formValue.status,
                    price_range: this.formValue.price_range,
                })
            })
            .then(response => response.json())
            .then(res => {
                this.apartments = res.data.apartments;
            });
        },
        showMenu(){
            if (document.getElementById('myStackernav').offsetWidth == 0) {
                this.showMenuBool = true;
                if(window.innerWidth >= 768){
                    document.getElementById('myStackernav').style.width = "350px";
                }else{
                    document.getElementById('myStackernav').style.width = "350px";
                }
            } else {
                this.showMenuBool = false;
                document.getElementById('myStackernav').style.width = "0px";
            }
        },
        PageViewCount(){
            if(sessionStorage.getItem('session_id') != null){
                let data = { 
                    session_id: sessionStorage.getItem('session_id'),
                    page_name: "Search Filter"
                }
                fetch(this.base_url+'AddPageView',{
                    method: 'POST', // or 'PUT'
                    headers: {
                        
                    },
                    body: JSON.stringify(data),
                    })
                .then(response => response.json())
                .then(res => {
                    
                });
            }
        }
    },
}
</script>

<style src="@vueform/slider/themes/default.css"></style>

<style scoped lang="scss">
* {
    font-family: "rustica-regular" !important;
}

.form-select{
    color:#000 !important;
    //font-family: "aeonik-regular" !important;
}

.menu-btn {
  position: absolute;
  z-index: 999;
  display: none;
  width:auto;
  button {
    border: none;
    background: #cad636;
    color: #fff;
    width: auto;
    height: 35px;
    margin: 20px;
    font-size: 14px;
    padding:0 10px
  }
}

.filter-view {
    //background:url('../assets/img/background.jpg');
    height:100%;
    background: #381b31;
}

.stackernav {
    display: none;
    height: calc(100% - 70px);
    width: 0;
    position: absolute;
    z-index: 1;
    top: 0px;
    left: 0;
    bottom: 0;
    background-color: #381b31;
    overflow-x: hidden;
    transition: 0.5s;
    margin-top: 0;
    .close-btn {
        border: none;
        position: absolute;
        top: 10px;
        right: 15px;
        background: transparent;
        i{
            color: #cad636;
            font-size: 35px;
        }
    }
}

.filters {
    background-color: transparent;
    height: 100%;
    padding-bottom:3rem;
    overflow-y:auto;
    // -ms-overflow-style: none; /* Edge, Internet Explorer */
    // scrollbar-width: none; /* Firefox */

    // &::-webkit-scrollbar {
    // display: none; /* Chrome, Safari, Opera */
    // }

    .heading {
        color: #fff;
        text-transform: uppercase;
        width: 80%;
        margin: 0 auto;
    }

    .filter-box {
        width: 85%;
        margin: auto;

        .filter-by {
            color: #fff;
            font-size: 20px;
        }

        .reset-btn {
            background: transparent;
            color: #fff;
            text-transform: uppercase;
            width: 100px;
            height: 20px;
            font-size: 12px;
            border: none;
            img {
                width: 20px;
            }
        }

        .filters-list {
            * {
                color: #fff;
                font-size: 18px;
            }

            p{
                padding: 5px 0;
                margin: 15px 0;
                border-bottom: 1px solid #fff;
            }

            .fitler-two {
                .chk-radio {
                    flex: 33%;
                }
            }
        }

        .apply-btn {
            background: #cad636;
            color: #fff;
            text-transform: uppercase;
            width: 150px;
            border: none;
            height: 40px;
        }
    }
}

.chk-radio {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 7px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default radio button */
.chk-radio input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    border: 1px solid #fff;
}

.chk-radio:hover input~.checkmark {
    background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.chk-radio input:checked~.checkmark {
    background-color: #cad636;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.slider-target{
  width: 90%;
  margin: 0px auto;
}

/* Show the indicator (dot/circle) when checked */
.chk-radio input:checked~.checkmark:after {
    display: block;
}

/* Style the indicator (dot/circle) */
.chk-radio .checkmark:after {
    left: 8px;
    top: 5px;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

@media screen and (max-width: 1366px) {
   .vfm--fixed {
        width: 60% !important;
        left:30% !important
    }
}

@media screen and (max-width: 810px) {
    
    .vfm--fixed {
        width: 50% !important;
        left:20% !important
    }
}

@media screen and (max-width: 767px) {
    
    .vfm--fixed {
        width: 100% !important;
        left: 0 !important;
        top: 1.5% !important;
        z-index: 9999!important;
    }

    .stackernav {
        top: 70px;
    }

    .filter-view {
      margin-top:70px
    }
}

@media screen and (max-width: 1024px) {
    .desktop{
        display: none!important;
        &::-webkit-scrollbar {
            width: 0px;
        }    
    }
    .menu-btn{
        display: block;
    }
    .desktop-2{
        width: 100%!important;
    }
    .stackernav{
        display: block;
    }
}

@media screen and (max-width: 800px) {

    .filters {
        &::-webkit-scrollbar {
            width: 0;
        }
    }


}

@media screen and (max-width: 1024px) {
    .filter-view {
      margin-top:70px !important
    }

    .filter-view .row {
        height: unset !important;
    }
}


</style>

<style>

.slider-tooltip {
  background: #cad636;
  border-color: #cad636;
}

.slider-connect {
  background: var(--slider-connect-bg,#cad636);
  cursor: pointer;
}

</style>
